import { AbstractControl, ValidatorFn } from '@angular/forms';
import { ILanguage } from '../types';

// Validate that typed preferred language is empty or  exists in list of valid languages
export function PreferredLanguageValidator(index: number, validLanguages: ILanguage[]): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } | null => {
		const userLanguageElement = document.getElementById('preferredLanguage' + index) as any;

		if (userLanguageElement) {
			const userLanguage = userLanguageElement.value ? userLanguageElement.value : '';

			if (
				!userLanguage.trim() ||
				validLanguages.some((language) => {
					const userLangLower = userLanguage.toLowerCase();

					if (language.name.toLowerCase() === userLangLower) {
						return true;
					} else {
						return false;
					}
				})
			) {
				return null;
			}

			return { invalidLanguage: true };
		}
	};
}
